import { render, staticRenderFns } from "./BaseRulesPanel.vue?vue&type=template&id=1ed1de58"
import script from "./BaseRulesPanel.vue?vue&type=script&lang=js"
export * from "./BaseRulesPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseRulesPanel.vue?vue&type=style&index=0&id=1ed1de58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports